import React from 'react';

const WishlistButton = ({ label, articleNumber, href, cssClass, onClick }) => (
    <a className={cssClass} onClick={() => onClick()}>
        {label}
    </a>
);

export default WishlistButton;
